import {appUrls} from "helpers/Urls";
import {useParams} from "react-router-dom";
import axios from "axios";

export const sendResponseInvitation = ({isAccepted,id}) => {
    const {data} = axios.post(appUrls.sendResponseToInvite(id, isAccepted))
    return {data}

}
export const getInvite = async (id) => {
    const response = await axios.get(appUrls.assistantInvite(id))
    return response?.data

}